import axios from 'axios';

export default class MavenPolicies {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async getPolicies(brandId, type) {
    const result = await axios.get(`${this.baseURL}/account/${brandId}/${type}`);
    return result.data;
  }

  async createPolicy(brandId, type, policy) {
    const result = await axios.post(`${this.baseURL}/account/${brandId}/${type}`, policy);
    return result.data;
  }

  async updatePolicy(brandId, type, id, policy) {
    const result = await axios.put(`${this.baseURL}/account/${brandId}/${type}/${id}`, policy);
    return result.data;
  }

  async deletePolicy(brandId, type, id) {
    return axios.delete(`${this.baseURL}/account/${brandId}/${type}/${id}`);
  }

  async swapOrder(brandId, id1, id2) {
    const result = await axios.post(`${this.baseURL}/account/${brandId}/rules/swap-order`, [id1, id2]);
    return result.data;
  }
}
